import { routesTemplate } from "../routesTemplate";

import DeliveryHub from "../../screens/journeyDeliveries/DeliveryHub";

import PlayerDeliveryScreen from "../../screens/journeyDeliveries/PlayerDeliveryScreen";
import PlayerDeliveryComposer from "../../screens/journeyDeliveries/PlayerDeliveryComposer";

import DeliverableReviewsScreen from "../../screens/journeyDeliveries/DeliverableReviewsScreen";

import JourneyDeliveries from "../../screens/journeyDeliveries/JourneyDeliveries";

import DeliveryReviewScreen from "../../screens/journeyDeliveries/DeliveryReviewScreen";

export const journeyDeliveryStack = [

    routesTemplate('/applications', DeliveryHub),

    routesTemplate('/applications/userApplications', PlayerDeliveryScreen ),
    routesTemplate('/applications/userApplications/composer', PlayerDeliveryComposer ),
    routesTemplate('/applications/userApplications/review', DeliverableReviewsScreen ),

    routesTemplate('/applications/journeys', JourneyDeliveries),

    routesTemplate('/applications/review', DeliveryReviewScreen),
];
